import { Button, Form, Modal, message, Table, Space } from '@drip/drip-design';
import React, { useEffect, useState } from 'react';
import ValidateErp from '@/components/validate-erp';
import { addManager, managerList, deleteManager } from '../../apis';
import Delete from '@/components/delete';
import './index.less';

interface PropsType {
  id: string;
  children: React.ReactElement;
}

const AuthMange: React.FC<PropsType> = (props) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const { id } = props;
  const [erpData, setErpData] = useState({ list: [], totalCount: 0 });
  const [conditions, setConditions] = useState({ whiteIds: [id], currentPage: 1, pageSize: 10, totalCount: 0 });

  let btn = React.cloneElement(props.children, {
    onClick: () => setVisible(true),
  });

  useEffect(() => {
    if (!visible) return;
    managerList(conditions)
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret !== '0' || !data) throw msg || '管理员列表请求失败';
        setErpData(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [conditions, visible]);

  const formSubmit = ({ erps }: { erps: string }) => {
    addManager({ whiteId: id, erps: erps.split(/,|，/) })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || 'erp保存失败，请稍后再试';
        form.resetFields();
        setConditions({ ...conditions });
        message.success('erp添加成功');
      })
      .catch((ex) => {
        message.error(ex);
      });
  };

  const deleteErp = (erp: string) => {
    deleteManager({ whiteId: id, erps: [erp] })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0') throw msg || 'erp删除失败';
        setConditions({ ...conditions });
        message.success('erp删除成功');
      })
      .catch((ex) => {
        message.error(ex);
      });
  };

  const columns = [
    {
      title: 'erp',
      render(record: any) {
        const { erp, realName, headImg, positionName } = record;
        return (
          <Space>
            <img src={headImg} width={40} />
            <div>
              <div>{realName + `(${erp})`}</div>
              <div>{positionName}</div>
            </div>
          </Space>
        );
      },
    },
    {
      title: '权限类型',
      dataIndex: 'isOwner',
      render(isOwner: any) {
        return isOwner ? '创建人' : '管理者';
      },
    },
    {
      title: '操作',
      render(record: any) {
        const { isOwner, erp } = record;
        return isOwner ? null : (
          <Delete onConfirm={() => deleteErp(erp)}>
            <a>删除</a>
          </Delete>
        );
      },
    },
  ];

  return (
    <>
      {btn}
      <Modal
        width={800}
        title="权限管理"
        visible={visible}
        footer={null}
        onCancel={() => {
          form.resetFields();
          setVisible(false);
        }}
        className="auth-manage-modal"
      >
        <h4>添加管理组成员</h4>
        <Form form={form} layout="vertical" onFinish={formSubmit}>
          <Space>
            <ValidateErp
              validateTrigger="Onblur"
              name="erps"
              label="erp账号"
              type="default"
              placeholder="请输入erp，多个erp用英文逗号隔开"
              style={{ width: 655 }}
            />
            <Button type="primary" onClick={() => form.submit()} className="add-erp-btn">
              添加成员
            </Button>
          </Space>
        </Form>
        <h4>成员管理{erpData.totalCount > 0 && `(${erpData.totalCount})`}</h4>
        <Table
          dataSource={erpData.list}
          columns={columns}
          pagination={{
            hideOnSinglePage: true,
            total: erpData.totalCount,
            pageSize: conditions.pageSize,
            current: conditions.currentPage,
            showSizeChanger: false,
            onChange(page) {
              setConditions({ ...conditions, currentPage: page });
            },
          }}
        />
      </Modal>
    </>
  );
};

export default AuthMange;
